<template>
  <div class="container-fluid home-bg py-4">
    <div class="row">
      <div class="col-lg-12 col-md-12 mb-md-0 mb-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <div class="row">
              <div class="col-lg-8 col-md-6">
                <h6 style="color: black">Cursos</h6>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4 col-md-4 col-sm-4 mb-xl-0 mb-4 mt-4 p-4" v-for="item in Platforms" :key="item.id" >
              
                <div v-if="item.subscribe == 0" class="card" style="background-color: #f4f5f6; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);">
                  <div class="card-body p-0" style="height: 300px">
                    <div class="row">
                      <img v-if="item.url_image"
                        :src="item.url_image"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"
                      />
                      <img v-else
                        src="../../core_assets/img/bruce-mars.jpg"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"/>
                    </div>
                  
                    <div class="row">
                      <div class="col-12 mt-2 ms-2">
                        <h6 style="color: black">
                          {{ item.name.length > 27 ? item.name.substring(0, 27) + '...' : item.name }}
                        </h6>

                          <div>
                            <h7 v-if="item.autoapproved == 1 || item.amount == 0 || !item.amount">Gratis</h7>
                            <h7 v-else>{{ item.amount }}$</h7>
                              <button type="button" class="btn btn-sm bg-gradient-fvf me-4 float-right" @click.prevent="goToPlataform(item.id)">
                                Postularme
                              </button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="item.subscribe == 1" class="card" style="background-color: #f4f5f6; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);">
                  <div class="card-body p-0" style="height: 300px">
                    <div class="row">
                        <v-icon name="clock" fill="#b49b57" style="position: absolute; height: 60px; width: 60px; margin-left: 85%; padding-left: 0px;"></v-icon>
                      <img v-if="item.url_image"
                        :src="item.url_image"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"
                      />
                      <img v-else
                        src="../../core_assets/img/bruce-mars.jpg"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"/>
                    </div>
                    <div class="row">
                      <div class="col-12 mt-2 ms-2">
                        <h6 style="color: black">
                          {{ item.name.length > 27 ? item.name.substring(0, 27) + '...' : item.name }}
                        </h6>
                          <div>
                            <h7 v-if="item.autoapproved == 1 || item.amount == 0 || !item.amount">Gratis</h7>
                            <h7 v-else>{{ item.amount }}$</h7>
                              <button type="button" class="btn btn-sm bg-gradient-fvf me-4 float-right" @click.prevent="goToPlataform(item.id)">
                                Ver detalles
                              </button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="item.subscribe == 2" class="card" style="background-color: #f4f5f6; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);">
                  <div class="card-body p-0" style="height: 300px">
                    <div class="row">
                        <v-icon name="times" fill="red" style="position: absolute; height: 60px; width: 60px; margin-left: 85%; padding-left: 0px;"></v-icon>
                      <img v-if="item.url_image"
                        :src="item.url_image"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"
                      />
                      <img v-else
                        src="../../core_assets/img/bruce-mars.jpg"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"/>
                    </div>
                    <div class="row">
                      <div class="col-12 mt-2 ms-2">
                        <h6 style="color: black">
                          {{ item.name.length > 27 ? item.name.substring(0, 27) + '...' : item.name }}
                        </h6>
                          <div>
                            <h7 v-if="item.autoapproved == 1 || item.amount == 0 || !item.amount">Gratis</h7>
                            <h7 v-else>{{ item.amount }}$</h7>
                              <button type="button" class="btn btn-sm bg-gradient-fvf me-4 float-right" @click.prevent="goToPlataform(item.id)">
                                Ver detalles
                              </button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="item.subscribe == 3" class="card" style="background-color: #f4f5f6; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);">
                  <div class="card-body p-0" style="height: 300px">
                    <div class="row">
                        <v-icon name="check-circle" fill="#66FF00" style="position: absolute; height: 60px; width: 60px; margin-left: 85%; padding-left: 0px;"></v-icon>
                      <img v-if="item.url_image"
                        :src="item.url_image"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"
                      />
                      <img v-else
                        src="../../core_assets/img/bruce-mars.jpg"
                        alt="..."
                        class="img-fluid m-0"
                        style="height: 200px; width: 100%; margin: none; object-position: center; border-radius: 8% 8% 0 0; object-fit: cover;"/>
                    </div>
              
                    <div class="row">
                      <div class="col-12 mt-2 ms-2">
                        <h6 style="color: black">
                          {{ item.name.length > 27 ? item.name.substring(0, 27) + '...' : item.name }}
                        </h6>
                          <div>
                            <h7 v-if="item.autoapproved == 1 || item.amount == 0 || !item.amount">Gratis</h7>
                            <h7 v-else>{{ item.amount }}$</h7>
                              <button type="button" class="btn btn-sm bg-gradient-fvf me-4 float-right" @click.prevent="goToPlataform(item.id)">
                                Ver detalles
                              </button>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import moment from "moment";
import LTable from "src/components/Table_Home.vue";
import Card from "src/components/Cards/Card.vue";

export default {
  name: "Overview",
  components: {
    Card,
    LTable,
  },

  computed: {
    polar: function () {
      return "../../../public/logo_polar.png";
    },
  },
  data() {
    return {
      id_role: Cookies.get("id_role"),
      Platforms: [],

    };
  },
  mounted() {
    console.log(this.id_role);
    // this.isAdmin(this.role);
    this.loadPlatform();
  },
  methods: {
    ...mapActions(["getData", "changeStatusData"]),

    changeStatus(data) {
      console.log("UPDATING");
      this.idTemp = data.id;
      this.ref_img = data.url_image;
      console.log(this.idTemp);
      this.getElement(this.idTemp);
      setTimeout(() => {
        $("#modalApproved" + this.idTemp).modal("toggle");
      }, 100); // tiempo en milisegundos

      this.modalActiveUpdate = true;
    },

    goTo(name) {
      this.$router.push(name);
    },

    goToPlataform(id) {
      this.$router.push({ path: '/platform/' + id });
    },

    goToCourse(url) {
      window.open(url, '_blank');
    },

    loadPlatform() {
      let form = {
        url: "user/platform/all",
        params: {
          active: 1,
          order_key: "id",
          order_value: "desc",
        },
      };
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.Platforms = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    isAdmin(role) {
      console.log(role);
      if (this.role === 2) {
        Swal.fire({
          title: "Prohibido acceso",
          text: "Este usuario no puede acceder al panel administrativo",
          icon: "warning",
          customClass: {
            confirmButtonColor: "#B49B57",
            confirmButton: "btn bg-gradient-fvf",
          },
        });
        this.$router.push("/login");
      }
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    // Agrega los métodos que necesites aquí
  },
};
</script>

<style>
.addess_over td:nth-child(3) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 120px;
  width: 120px;
}

.addess_over td:last-child {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 200px;
  width: 100%;
  padding-left: 100px;
  display: flex !important;
  /* Establecer el elemento como un contenedor flexible */
  flex-wrap: wrap;
  /* Permitir que los botones se ajusten a la celda */
}

.addess_over td:last-child .btn {
  flex: 1 0 auto;
  margin: 1px;
  /* Reducir la distancia entre botones */
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
}

.circle_fvf {
  height: 35px;
  width: 35px;
  background-color: #643047; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_fvf_gold {
  height: 35px;
  width: 35px;
  background-color: #b49b57; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_black {
  height: 35px;
  width: 35px;
  background-color: black; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_red {
  height: 30px;
  width: 30px;
  background-color: #ce0d0d; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_blue {
  height: 30px;
  width: 30px;
  background-color: #003068; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_yellow {
  height: 30px;
  width: 30px;
  background-color: #ffc700; /* Cambia esto al color que desees */
  border-radius: 50%;
}

.circle_redwine {
  height: 20px;
  width: 20px;
  background-color: #541a32; /* Cambia esto al color que desees */
  border-radius: 50%;
}
</style>
<!-- <script src="../../core_assets/js/plugins/perfect-scrollbar.min.js"></script> -->
<!-- <script src="../../core_assets/js/plugins/smooth-scrollbar.min.js"></script>


 <script>
// var win = navigator.platform.indexOf("Win") > -1;
// if (win && document.querySelector("#sidenav-scrollbar")) {
//   var options = {
//     damping: "0.5",
//   };
//   Scrollbar.init(document.querySelector("#sidenav-scrollbar"), options);
// }
</script> -->
<!-- <script src="../../core_assets/js/soft-ui-dashboard.min.js?v=1.0.7"></script> -->
